import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ModificationPowerJunctionBoxReplacementReasonForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.MODIFICATION_POWER_JUNCTION_BOX_REPLACEMENT_REASON
    >();

    const convertValue = (): string => {
        if (values.modificationPowerJunctionBoxReplacementReason.value.defect) return "defect";
        if (values.modificationPowerJunctionBoxReplacementReason.value.other) return "other";
        return "";
    };
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Änderungsgrund
                </h4>
                <p className={classes.p}>
                    Aus welchem Grund soll der Hausanschlusskasten getauscht werden?
                </p>{" "}
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.modificationPowerJunctionBoxReplacementReason.value = {
                                    defect: v.indexOf("defect") >= 0,
                                    other: v.indexOf("other") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="defect"
                            control={<Radio />}
                            label="Defekt"
                            text=""
                            error={
                                values.modificationPowerJunctionBoxReplacementReason.error != null
                            }
                        />
                        <FormControlLabel
                            value="other"
                            control={<Radio />}
                            label="Sonstiges"
                            text=""
                            error={
                                values.modificationPowerJunctionBoxReplacementReason.error != null
                            }
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
